<template>
  <div class="input-container" :class="inline ? 'input-container-inline' : ''">
    <div class="input-label">{{ label }}</div>
    <template v-if="keys.length > 1">
      <input v-for="(key, index) in keys" v-bind:key="index" :type="valueType" :disabled="disabled" class="form-control" :placeholder="placeholder[index]" :value="modelValue[key]" @input="e => changeObjectInput(key, e.target.value)" >
    </template>
    <template v-else>
      <textarea v-if="type === 'textarea'" class="form-control" :disabled="disabled" :placeholder="placeholder" :value="modelValue" @input="e => $emit('modelEvent', e.target.value)" />
      <input v-else class="form-control" :type="valueType" :placeholder="placeholder" :disabled="disabled" :min="min" :max="max" :value="modelValue" @input="e => $emit('modelEvent', e.target.value)" />
    </template>
    <div class="delete-button" v-if="deletable" @click="$emit('delete-button-clicked')">X</div>
  </div>
</template>

<script>
export default {
  name: "InputGroup",
  model: {
    prop: 'modelValue',
    event: 'modelEvent'
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: [String, Array],
      default: ""
    },
    modelValue: [String, Object, Number],
    keys: {
      type: Array,
      default: () => []
    },
    inline: {
      type: Boolean,
      default: false
    },
    deletable: Boolean,
    type: String,
    disabled: Boolean,
    valueType: {
      type: String,
      default: 'text'
    },
    min: [Number, String],
    max: [Number, String]
  },
  methods: {
    changeObjectInput(key, value) {
      const newValue = { ...this.modelValue, [key]: value }
      this.$emit('modelEvent', newValue)

      setTimeout(() => console.log(this.modelValue), 500)
    }
  }
}
</script>

<style scoped>
.input-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0;
  pointer-events: all;
  font-size: 16px;
}

.input-container input, .input-container textarea {
  display: inline-block;
  flex: 1;
  margin: 5px 0;
  border: 1px solid #BB86FC;
  border-radius: 0;
  padding-bottom: 20px;
}

.input-container textarea {
  padding: 5px 10px 30px;
}

.input-container .input-label{
  display: inline-block;
  color: #BB86FC;
}

.input-container-inline .input-label {
  width: 15%;
}

.input-container-inline {
  flex-direction: row;
  align-items: center;
}

.input-container-inline input {
  margin: 5px 10px;
}

.delete-button {
  color: red;
  cursor: pointer;
}

.form-control {
  font-size: 16px;
}

</style>